<template>
	<div class="container">
		<el-container>
			<el-header class="header">
				<headers />
			</el-header>
			<el-container>
				<slider />
				<el-main>
					<div class="main_box">
						<div class="main_main">
							<!-- Page Header -->
							<div class="page_header">Manage Training</div>
							<!-- Page Header -->
				
							<div class="page_main">
								<div class="file-panel">
									<div class="panel-header">
										<div class="panel-title">Training Requirements</div>
										<div class="panel-actions">
											<el-input
												v-model="requirementKeyword"
												placeholder="Search"
												clearable
												class="search-input"
											>
												<i slot="prefix" class="el-input__icon el-icon-search"></i>
											</el-input>
										</div>
									</div>
				
									<el-table
										:data="requirementTableData"
										border
										class="file-table"
										header-cell-class-name="table-header-cell"
										empty-text="No training requirements found"
									>
										<el-table-column label="Action" width="110" align="center">
											<template slot-scope="scope">
												<el-button
													type="primary"
													size="mini"
													@click="handleManage(scope.row)"
												>
													Manage
												</el-button>
											</template>
										</el-table-column>
				
										<el-table-column
											prop="item_name"
											label="Training Item ID"
											min-width="260"
											sortable
										/>
				
										<el-table-column
											prop="leixing_name"
											label="Training Item Type"
											min-width="320"
											sortable
										/>
				
										<el-table-column
											prop="uncomplete"
											label="Incomplete"
											min-width="180"
											sortable
										>
											<template slot-scope="scope">
												{{ scope.row.num1 }}
											</template>
										</el-table-column>
				
										<el-table-column
											prop="unallocate"
											label="Unassigned"
											min-width="180"
											sortable
										>
											<template slot-scope="scope">
												{{ scope.row.num2 }}
											</template>
										</el-table-column>
				
										<el-table-column
											prop="overdue"
											label="Overdue"
											min-width="180"
											sortable
										>
											<template slot-scope="scope">
												{{ scope.row.num3 }}
											</template>
										</el-table-column>
				
										<el-table-column
											prop="earliest_time"
											label="Earliest Due Date"
											min-width="180"
											sortable
										>
											<template slot-scope="scope">
												{{ scope.row.end_time }}
											</template>
										</el-table-column>
									</el-table>
								</div>
							</div>
						</div>
					</div>
				</el-main>
			</el-container>
		</el-container>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading">
				<van-loading />
			</div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
	import {
		trainTongji
	} from "@/api/trainManage/manageTrain/index";
	import headers from "@/component/header.vue";
	import slider from "@/component/slider.vue";
	import moment from "moment";
	export default {
		components: {
			headers,
			slider,
		},
		data() {
			return {
				isLoading: true,
				requirementKeyword: "",
				requirementSource: [],
			};
		},
		created() {
			let that = this;
		},
		mounted() {
			let that = this;
			that.isLoading = false;
			that.getTableData();
		},
		computed: {
			requirementTableData() {
				return this.filterTableData(
					this.requirementSource,
					this.requirementKeyword
				);
			},
		},
		methods: {
			//时间戳转换
			initTime(value) {
				if (value) {
					return moment(value * 1000).format("YYYY-MM-DD");
				}
			},
			getTableData() {
				let that = this;
				//请求管理培训列表
				trainTongji().then((res) => {
					that.requirementSource = res.data;
				});
			},
			filterTableData(source, keyword) {
				if (!keyword || !keyword.trim()) return source;
				const lowerKeyword = keyword.toLowerCase().trim();
				return source.filter((item) => {
					const text = this.flattenValues(item).toLowerCase();
					return text.includes(lowerKeyword);
				});
			},
			flattenValues(data) {
				if (data === null || data === undefined) return "";
				if (Array.isArray(data)) {
					return data.map((item) => this.flattenValues(item)).join(" ");
				}
				if (typeof data === "object") {
					return Object.values(data)
						.map((val) => this.flattenValues(val))
						.join(" ");
				}
				return String(data);
			},
			handleManage(value) {
				let that = this;
				switch (value.train_type) {
					case 1:
						that.$router.push({
							path: "/TrainControl/manage-train",
							query: {
								type: "overview",
								recordId: value.item_id,
								recordName: encodeURIComponent(value.item_name),
							},
						});
						break;
					case 2:
						that.$router.push({
							path: "/TrainControl/manage-train",
							query: {
								type: "demand",
								recordId: value.record_id,
								recordName: encodeURIComponent(value.item_name),
							},
						});
						break;
				}
			},
			//跳转页面
			goUrl(url) {
				let that = this;
				that.$router.push(url);
			},
		},
	};
</script>

<style lang="less" scoped>
	//主要内容
	.main_main {
		.page_main {
			padding: 18px 20px;

			.btn_el {
				margin: 10px 0 20px 0;

				.tips {
					padding: 6px 8px;
					background-color: #ffb1001a;
					border-radius: 6px;
					font-size: 16px;
					font-weight: bold;
				}
			}
		}

		//页头
		.page_header {
			padding: 0 20px;
			height: 60px;
			line-height: 60px;
			background-color: #d8e4f0;
			font-size: 24px;
			font-weight: bold;
			box-shadow: 0 2px 4px rgba(0, 0, 0, 0.075);
		}
	}
</style>
<style scoped>
	.main_box {
		height: calc(100vh - 60px);
		overflow-y: auto;
	}

	.main_box .main_main {
		position: relative;
		min-height: calc(100% - 0px);
		max-height: auto;
		background-color: #fafafa;
	}

	.el-header,
	.el-main {
		padding: 0;
	}

	.file-panel {
		background: #fff;
		border: 1px solid #dcdfe6;
		margin-top: 20px;
	}

	.panel-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 8px 10px 0;
	}

	.panel-title {
		font-size: 18px;
		font-weight: 700;
		color: #222;
		line-height: 32px;
	}

	.panel-actions {
		display: flex;
		align-items: center;
		gap: 10px;
	}

	.search-input {
		width: 220px;
	}

	.file-table {
		width: 100%;
		margin-top: 8px;
	}

	::v-deep .el-form-item__label {
		font-size: 16px;
		color: #222;
		font-weight: 700;
		padding-bottom: 8px;
		position: relative;
	}

	::v-deep .btn span {
		text-decoration: underline;
	}
</style>